<div class="header">
    <div class="title">
        <img alt="PennDOT TIRe" src="{{imagePath}}/penndot_logo_glow.png">
        <h1>Traffic Information Repository (TIRe)</h1>
    </div>
    <div class="right-side">
        <div class="search-container">
            <mc-search id="search" #search slot="top-right" max-results="50" add-selection-to-map="true"></mc-search>
        </div>
        <div class="button-container">
            <button class="btn aoi" (click)="openAoi()">
                <span class="icon-ui-maps before"></span>
                <span class="text">Area of Interest</span>
            </button>
            <button class="btn layers" (click)="openLayerCatalog()">
                <span class="icon-ui-layers before"></span>
                <span class="text">Layers</span>
            </button>
            <button class="btn tools" (click)="toggleTools()">
                <span class="icon-ui-layer-list before"></span>
                <span class="text">Tools</span>
            </button>
            <button class="btn map" *ngIf="isLoggedIn" (click)="toggleMapsMenu()">
                <span class="icon-ui-maps before"></span>
                <span class="text">Map</span>
                <div class="drop-down" *ngIf="showMapMenu">
                    <div class="menu">
                        <a class="dropdown-link glossary" href="javascript:;" (click)="openSaveMapWindow()">
                            <span class="icon-ui-save" title="Save Map"></span>
                            <span class="text">Save Map...</span>
                        </a>
                        <a class="dropdown-link map-catalog" href="javascript:;" (click)="openMapCatalog()">
                            <span class="icon-ui-maps" title="Open Saved Maps"></span>
                            <span class="text">Open Saved Maps</span>
                        </a>
                        <a class="dropdown-link glossary" href="javascript:;" (click)="openPrintWindow()">
                            <span class="icon-ui-printer" title="Print Map"></span>
                            <span class="text">Print Map</span>
                        </a>
                    </div>
                </div>
            </button>
            <button class="btn login" [class.logged-in]="isLoggedIn" (click)="toggleLoginMenu()">
                <span class="icon-ui-user"></span>
                <span class="icon-ui-down-arrow icon-ui-flush after"></span>
                <div class="drop-down" *ngIf="showLoginMenu">
                    <div class="menu">
                        <a class="dropdown-link user" href="javascript:;" (click)="login()">
                            <span class="esri-icon-user"></span>
                            <span *ngIf="!isLoggedIn">Login</span>
                            <span *ngIf="isLoggedIn">Logged in as {{ username }}</span>
                        </a>
                        <a class="dropdown-link logoff" *ngIf="isLoggedIn" href="javascript:;" (click)="logout()">
                            <span class="icon-ui-sign-out"></span> Logoff
                        </a>
                        <a class="dropdown-link logoff" *ngIf="isLoggedIn" href="javascript:;" (click)="openUserSettings($event)">
                            <span class="icon-ui-settings2"></span> User Settings
                        </a>
                        <a class="dropdown-link logoff" *ngIf="isLoggedIn" href="javascript:;" (click)="openBookmarks($event)">
                            <span class="icon-ui-tag"></span> Bookmarks
                        </a>
                    </div>
                </div>
            </button>
            <button class="btn about" (click)="toggleAboutMenu()">
                <span class="icon-ui-description before"></span>
                <span class="text">About</span>
                <div class="drop-down" *ngIf="showAboutMenu">
                    <div class="menu">
                        <a class="dropdown-link about" href="javascript:;" (click)="openAbout()">
                            <span class="icon-ui-description" title="About"></span>
                            <span class="text">About</span>
                        </a>
                        <a class="dropdown-link help" href="{{rootUrl}}/WebHelp" target="_blank">
                            <span class="icon-ui-question" title="Help"></span>
                            <span class="text">Help</span>
                        </a>
                        <a class="dropdown-link contact-us" href="javascript:;" (click)="openContactUs()">
                            <span class="icon-ui-contact" title="Contact Us"></span>
                            <span class="text">Contact Us</span>
                        </a>
                        <a class="dropdown-link glossary" href="{{rootUrl}}/glossary" target="_blank">
                            <span class="icon-ui-documentation" title="Glossary"></span>
                            <span class="text">Glossary</span>
                        </a>
                        <a class="dropdown-link show-mobile" href="{{rootUrl}}?showMobile=true" target="_blank">
                            <span class="icon-ui-mobile" title="Show Mobile"></span>
                            <span class="text">Show Mobile</span>
                        </a>
                    </div>
                </div>
            </button>
        </div>
    </div>
</div>

<app-tools #tools></app-tools>

<mc-window #aoiWindow id="aoiWindow" modal="true" title="Select an Area of Interest" width="750">
    <div slot=content>
        <app-aoi #aoi id="aoi" [mapRef]="mcMap"></app-aoi>
    </div>
</mc-window>

<mc-window #layerCatalogWindow modal="true" title="Layer Catalog" is-resizable="true" is-draggable="true" height="700"
    width="760" (openChange)="layerCatalogWindowOpenChange($event)">
    <mc-layer-catalog #layerCatalog slot="content" filter-layers-before-add="true"
        (layersAdded)="layersAddedFromCatalog($event)"></mc-layer-catalog>
</mc-window>

<mc-window #mapCatalogWindow modal="true" title="Map Catalog" width="800" height="700">
    <mc-map-catalog #mapCatalog slot="content" application-id="{{appId}}" show-user-maps="true" show-system-maps="true" [loggedIn]="isLoggedIn" (shouldLogIn)="login()" (ondone)="closeMapCatalog()"></mc-map-catalog>
</mc-window>

<mc-window #saveMapWindow id="saveMapWindow" title="Save Map" is-draggable="true" is-resizable="true" min-width="500"
    min-height="400">
    <mc-save-map #saveMap slot="content"></mc-save-map>
</mc-window>

<mc-window #shareMapWindow id="shareMapWindow" title="Share Map" is-draggable="true" is-resizable="true" min-width="500"
           min-height="400">
    <mc-share-map #shareMap slot="content"></mc-share-map>
</mc-window>

<mc-window #unshareMapWindow id="unshareMapWindow" title="Unshare Map" is-draggable="true" is-resizable="true"
           min-width="500" min-height="400">
    <mc-unshare-map #unshareMap slot="content"></mc-unshare-map>
</mc-window>

<mc-window #printWindow id="printWindow" title="Print Map" is-draggable="true" is-resizable="true" height="850px"
    width="475px" (openChange)="onPrintWindowOpenChange($event)">
    <mc-print #print slot="content"></mc-print>
</mc-window>

<mc-window #aboutWindow id="aboutWindow" title="About TIRE" modal="true" width="700">
    <div slot="content">
        <div class="about-window">
            <h3>PennDOT Traffic Information Repository (TIRe)</h3>
            <h5>Version: {{ version }}</h5>
            <p> Welcome to <strong>TIRe</strong> (Traffic Information Repository), a web application for providing
                traffic count data to
                various agencies and to the public. TIRe is designed to enable Internet users to view interactive maps
                of traffic counter site locations and traffic count information for roadways throughout the Commonwealth
                of Pennsylvania.
            </p>
            <div class="bottom">
                <button class="btn right" (click)="closeAbout()">Close</button>
            </div>
        </div>
    </div>
</mc-window>

<mc-window #contactUsWindow id="contactUsWindow" title="Contact Us" modal="true" width="700">
    <div slot="content">
        <div class="about-window">
            <p> Please feel free to contact a representative with any questions, comments or issues at the following
                email:
                <a href="mailto:ra-penndottrafficstats@state.pa.us">ra-penndottrafficstats@state.pa.us</a>
            </p>
            <div class="bottom">
                <button class="btn right" (click)="closeContactUs()">Close</button>
            </div>
        </div>
    </div>
</mc-window>

<mc-window #bookmarksWindow is-resizable="false" title="Bookmarks" is-draggable="true" height="583" width="500">
    <mc-bookmark #bookmarks slot="content" app-name="TIRE"></mc-bookmark>
</mc-window>

<mc-window #userSettingsWindow title="User Settings" is-draggable="true" height="725" top="70" width="450">
    <mc-user-settings #userSettings slot="content" app-name="TIRE" active="true" (activeChange)="userSettingsActive($event)" (settingsLoaded)="userSettingsLoaded($event)"></mc-user-settings>
</mc-window>